<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}s
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-4">
            <table>
              <tr>
                <td>
                  <a @click="exportTransaction()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a>
                </td>
                <td>
                  <flat-pickr :config="exportConfig" @on-change="changeDateBooking" v-model="exportDates" name="export_date_start" class="font-13"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-4 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
<!--          <template slot="name" slot-scope="data">-->
          <template v-slot:cell(name)="data">
            <template v-if="data.item.member">
              {{data.item.member.first_name}} {{data.item.member.last_name}}
            </template>
            <template v-else>-</template>
          </template>
          <template v-slot:cell(phone_number)="data">
            <span>{{ (data.item.member) ? data.item.member.phone_number : '-' }}</span>
          </template>
          <template v-slot:cell(gross_amount)="data">
            Rp. {{data.item.gross_amount}}
          </template>
          <template v-slot:cell(status)="data">
            <b-badge :variant="data.item.transaction_status_code == 200 ? 'success' : 'danger'">
              {{ data.item.transaction_status_code == 200 ? 'Success' : 'Failed' }}
            </b-badge>
          </template>
          <template v-slot:cell(date)="data">
            {{parseDateTime(data.item.created_at)}}
          </template>
          <template v-slot:cell(nameType)="data">
            <template v-if="data.item.membership_name">
              {{data.item.membership_name}}
            </template>
            <template v-else>
              {{data.item.package_name}}
            </template>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from 'moment'

export default {
  name: 'bookingHistory',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'id',
          label: 'TRX ID',
          sortable: true
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'branch.name',
          label: 'Branch Name',
          sortable: true
        },
        {
          key: 'transaction_type.name',
          label: 'Transaction Type',
          sortable: true
        },
        {
          key: 'nameType',
          label: 'Membership/Packge Name',
          sortable: true
        },
        {
          key: 'gross_amount',
          label: 'Total Price',
          sortable: true
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true
        },
        {
          key: 'date',
          label: 'Transaction Date',
          sortable: true
        },

        {
          key: 'payment_type_1.name',
          label: 'Payment Type 1',
          sortable: true
        },  {
          key: 'payment_type_2.name',
          label: 'Payment Type 2',
          sortable: true
        }
      ],
      items: [],
      dataBranch: [],
      branch_id: null,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    exportTransaction() {
      let dates = this.exportDates.split(' to ')
       let if_date_un = dates.length == 1 ? dates[0] : dates[1]
      let url = 'fitness/v1/export/payment_history?start_date='+dates[0]
        +'&end_date='+if_date_un
        +'&keyword=' + this.searchData

      if(this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Payment History Report '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeDateBooking(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    parseDateTime (value) {
      moment.locale('id')
      return moment(value).format('dddd, DD-MM-YYYY, HH:MM')
    },
    parseTime (value) {
      return (value).slice(0, -3)
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    parseImg (value) {
      return Auth.apiUrl + 'fitness/v1/img/member/' + value
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editBlogCategory (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    changeBranch(event) {
      let cutDate = this.exportDates.split(' to ')
      let if_date_un = cutDate.length == 1 ? cutDate[0] : cutDate[1]
      let url = 'fitness/v1/history/payment_history?page=' + this.currentPage
      + '&limit=' + this.paginationLimit
      + '&sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData
      + '&start_date=' + cutDate[0]
      + '&end_date=' + if_date_un

      if(event != null) {
        url += '&branch_id=' + event
      }

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      let cutDate = this.exportDates.split(' to ')
      let if_date_un = cutDate[1] == undefined ? cutDate[0] : cutDate[1]
      let url = 'fitness/v1/history/payment_history?page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData
        + '&start_date=' + cutDate[0]
        + '&end_date=' + if_date_un

      if(this.branch_id != null) {
        url += '&branch_id=' + this.branch_id
      }

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
